import api from './api';
import apiNoHeaders from './apiNoHeaders';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const apiRequest = environment === 'production' ? api : apiNoHeaders;

export const testApiV1Service = {
  getConnection
};

async function getConnection() {
  const response = await apiRequest.post(`${baseURL}/cliente`, {
    filtros: [
      {
        campo: 'id_cliente',
        criterio: 'igual',
        valor: 1
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  return environment === 'production' ? response.data.result : response.data;
}